import { all, put, fork, takeEvery, select } from 'redux-saga/effects';
import actions from './actions';
import { get } from '@iso/lib/helpers/resApiRequestor';

export function* fetchAuditLogs() {
  yield takeEvery(actions.FETCH_AUDIT_LOGS, function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.FETCHING_AUDIT_LOGS,
        loading: true,
        load_more: payload?.load_more
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAuditLogsAPI(payload, pagination, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_AUDIT_LOGS_SUCCESS,
          loading: false,
          message: result?.message,
          result: result?.data,
          pagination: result?.pagination,
          load_more: payload?.load_more
        });
      } else {
        yield put({
          type: actions.FETCH_AUDIT_LOGS_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_AUDIT_LOGS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

function* getRoleHeader() {
  const state = yield select();
  const identity = state.Auth.identity;
  const currentPage = state.App.currentPage;
  const currentAction = state.App.currentAction;
  if (currentAction) {
    return `${identity.role_id}:${currentPage.id}:${currentAction.id}`;
  } else {
    return `${identity.role_id}:${currentPage.id}`;
  }
}

function fetchAuditLogsAPI(data, pagination, roleAuth) {
  return get(`audit-logs`, data, pagination, null, null, roleAuth);
}

export default function* rootSaga() {
  yield all([fork(fetchAuditLogs)]);
}
